import ScrollContainer from 'react-indiana-drag-scroll';

import { CustomLink } from '../../../../components/CustomLink';
import { s3CloudFrontUrlEndpoint } from '../../../../utils/common';
import IgnoreParentPadding from '../../IgnoreParentPadding';

import SourcingWrapper from './SourcingWrapper';

const SourcingSecondSection = () => {
  const SLIDER_IMAGES = Array.from(
    { length: 3 },
    (_, i) =>
      `${s3CloudFrontUrlEndpoint}/mission/sourcing-slider-section2/v2/mo${i}.png`,
  );

  const BLOG_URLS = [`/blogs/post/105`, `/blogs/post/123`, `/blogs/post/108`];

  return (
    <SourcingWrapper
      index={1}
      title="남김없는 생산이 가능하도록"
      description={
        '농산물을 크기와 모양으로 구분짓지 않습니다. 구출이 필요한 농산물을 발굴합니다. 판로가 필요한 생산자와 함께합니다.'
      }
    >
      <IgnoreParentPadding px={16}>
        <ScrollContainer className="flex flex-row gap-16px overflow-x-auto overflow-y-hidden whitespace-nowrap">
          <div className="h-px w-px shrink" />
          {SLIDER_IMAGES.map((imgUrl, i) => (
            <CustomLink href={BLOG_URLS[i]} key={imgUrl} className="shrink-0 ">
              <img
                src={imgUrl}
                alt={`이미지 슬라이더 ${i}`}
                className="h-296px w-296px sm:h-319px sm:w-319px"
                loading="lazy"
              />
            </CustomLink>
          ))}
        </ScrollContainer>
      </IgnoreParentPadding>
    </SourcingWrapper>
  );
};

export default SourcingSecondSection;
